import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AppIconComponent } from '../../../lib/ui';
import { GlobalScannerService } from '../../../core/global-scanner.service';

@Component({
  selector: 'app-global-scanner',
  standalone: true,
  imports: [CommonModule, FormsModule, AppIconComponent],
  template: `
    <!-- Global Scanner Overlay -->
    <div
      *ngIf="isActive"
      class="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center"
      (click)="closeScanner()"
    >
      <div
        class="bg-white rounded-2xl p-8 max-w-md mx-4 text-center shadow-2xl animate-scale-in"
        (click)="$event.stopPropagation()"
      >
        <div
          class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4"
        >
          <app-icon name="qr_code_scanner" color="primary" [size]="32" />
        </div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">Scanner Ativo</h3>
        <p class="text-gray-600 mb-4">
          Aponte a câmera para o código de barras
        </p>
        <div class="space-y-3">
          <input
            #barcodeInput
            type="text"
            [(ngModel)]="scannedCode"
            (keyup.enter)="confirmScan()"
            placeholder="Ou digite o código manualmente..."
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
            autofocus
          />
          <div class="flex gap-2">
            <button
              (click)="confirmScan()"
              class="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
            >
              <app-icon name="check" [size]="16" class="inline mr-1" />
              Confirmar
            </button>
            <button
              (click)="closeScanner()"
              class="flex-1 bg-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-400 transition-colors"
            >
              <app-icon name="close" [size]="16" class="inline mr-1" />
              Cancelar
            </button>
          </div>
        </div>

        <!-- Instructions -->
        <div class="mt-4 text-xs text-gray-500 space-y-1">
          <p>💡 Dica: Use Ctrl+S para abrir o scanner</p>
          <p>🔍 Digite diretamente ou use a câmera</p>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      @keyframes scale-in {
        from {
          transform: scale(0.9);
          opacity: 0;
        }
        to {
          transform: scale(1);
          opacity: 1;
        }
      }

      .animate-scale-in {
        animation: scale-in 0.2s ease-out;
      }
    `,
  ],
})
export class GlobalScannerComponent implements OnInit, OnDestroy {
  isActive = false;
  scannedCode = '';
  private subscription = new Subscription();

  constructor(private globalScannerService: GlobalScannerService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.globalScannerService.scannerActive$.subscribe((isActive) => {
        this.isActive = isActive;
        if (isActive) {
          this.scannedCode = '';
          // Auto-focus no input após um breve delay
          setTimeout(() => {
            const input = document.querySelector(
              'input[placeholder*="código manualmente"]'
            ) as HTMLInputElement;
            if (input) {
              input.focus();
              input.select();
            }
          }, 100);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  confirmScan(): void {
    if (this.scannedCode.trim()) {
      this.globalScannerService.emitBarcodeScanned(this.scannedCode, 'manual');
      this.scannedCode = '';
    }
  }

  closeScanner(): void {
    this.globalScannerService.deactivateScanner();
  }
}
